// PermissionCategories only. Shared table methods are in tableMixin.js.
export default {
    name: "PermissionCategories",
    methods: {
        clearForm() {
            this.isEditing = false;
            this.isSaving = false;
            this.submitted = false;
            this.formInputs.id = "";
            this.formInputs.category_name = "";
            this.formInputs.description = "";
            this.$clearValidationStates("#recordForm");
        },
    },
};